import { getApi } from 'apis';

export const getAllCostCenter = async (params: any) => {
	return await getApi('/costCenter', params);
};
 